<template>
    <div id="uploadBox" @dragover.prevent @drop.prevent @drop="dragFile">
        <label class="formLabel" v-if="!fileUploaded.name || changeFiles">Browse or Drag and Drop Your Document</label>
        <transition name="fade">
        <div style="position:relative;" v-show="uploading">
            <transition name="fade">
            <div v-show="!showProgressBar">
                <img
                    :src="siteUrl + 'imgs/indicator.gif'"
                    alt=""
                    width="42"
                    height="28"
                />
            </div>
            </transition>
            <transition name="fade">
            <div class="progress" v-show="showProgressBar">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" 
                :style="{width: percentCompleted + '%'}"
                >{{percentCompleted}}%</div>
            </div>
            </transition>
            Please wait while your document uploads.
        </div>
        </transition>

        <div v-show="!uploading">
            <input
                class="formFileUploade"
                type="file"
                ref="file"
                @change="handleFileUpload()"
                v-if="!fileUploaded.name || changeFiles"
            />
            

            <div style="word-break: break-all;margin-bottom:5px;" v-show="fileUrl">
                Your Document Has Been Uploaded :<br>
                <a :href="siteUrl.slice(0, -1) + fileUrl">{{ fileName }}</a>
            </div>
            <a href="javascript:void(0)" class="button button-blue" @click="changeFiles=true" v-if="fileUploaded.name && !changeFiles">Change File</a>

            <div class="step3RightTxtNote">
                (*File size should not be more than 25 MB)<br />
                <span style="vertical-align:middle;"
                    >Supported file types:</span
                >
                <img
                    :src="siteUrl + 'imgs/2015/file-types.png'"
                    alt="File Types"
                    style="width:44px;height:26px;vertical-align:middle;"
                />
            </div>
            
            <transition name="fade">
                <div class="fileError" v-show="!validFile">
                    <p>
                        Only .doc, .docx and .pdf files are allowed to upload.
                    </p>
                </div>
            </transition>

            <transition name="fade">
                <div class="fileError" v-show="errors">
                    <p>{{ errors }}</p>
                </div>
            </transition>
           
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            file: '',
            errors: '',
            fileName: this.fileUploaded.name,
            fileUrl: this.fileUploaded.url,
            uploading: false,
            validFile: true,
            uploadedFile: false,
            percentCompleted: 0,
            showProgressBar: false,
            timeOut: false,
            changeFiles: false,
        };
    },
    props: {
        fileUploaded: [Object, Boolean]
    },
    created: function() {
        /*if(this.fileName) {
            this.uploadedFile = true;
        }*/
    },
    methods: {
        dragFile(e) {
            if(!this.fileUploaded.name || this.changeFiles) {
                this.file = e.dataTransfer.files[0];
                this.handleFileUpload(this.file);
            }
        },
        checkUpload() {
            //this.$refs.file.click();
            return false;
        },
        turnErrorsOff() {
            this.errors = '';
            this.uploadedFile = '';
            this.deletedFile = '';
        },
        handleFileUpload(file) {
            this.turnErrorsOff();
            this.percentCompleted=0;
            this.showProgressBar = false;
            this.timeOut = setTimeout(() => this.displayProgressBar(), 3000);
            if(!file) {
                // case not drag and drop
                this.file = this.$refs.file.files[0];
            } 
            
            const extension = this.getFileExtension(this.file.name);
            this.checkIfValidFileType(extension);
            if(this.file.size > 25*1024*1024) {
                // maximum allowed 25 mb
                this.errors = 'Maximum file size allowed is 25 MB';
                this.clearProgressTimeout();
            } else if (this.checkIfValidFileType(extension)) {
                this.validFile = true;
                this.uploadFile();
            } else {
                this.validFile = false;
                this.clearProgressTimeout();
            }
        },
        displayProgressBar() {
            this.showProgressBar = true;
        },
        clearProgressTimeout() {
            clearTimeout(this.timeOut);
        },
        uploadFile() {
            this.uploading = true;
            const formData = new FormData();
            formData.append('file', this.file);
            let config = '';
            config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function(progressEvent) {
                    this.percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    console.log (this.percentCompleted);
                    //console.log (progressEvent.total);
                }.bind(this)
            };

            axios
            .post(
                this.siteUrl + 'include/API/sampleUpload.php',
                formData,
                config
            )
            .then(response => {
                if (response.data.errors) {
                    this.errors = response.data.errors;
                } else {
                    this.fileUrl = response.data.url;
                    this.fileName = response.data.name;
                    this.uploadedFile = true;
                    this.changeFiles=false;
                    this.$emit('fileUploaded', response.data);
                }
                this.showProgressBar = false;
                this.uploading = false;
            });
        },
        checkIfValidFileType(ext) {
            const validTypes = ['doc', 'docx', 'pdf'];
            if (validTypes.includes(ext)) {
                return true;
            }
            return false;
        },
        getFileExtension(file) {
            const re = /(?:\.([^.]+))?$/;
            const ext = re.exec(file)[1];
            return ext;
        },
    },
}
</script>

<style lang="scss" scoped>
.fileUploadDiv {
    overflow: hidden;
    margin-right: 20px;
}
.fileError {
    margin: 10px 20px 15px 0;
    padding: 10px 15px 10px 15px;
    background-color: #faebec;
    border: #d8b5b7 1px solid;
    p {
        margin: 0;
        color: #ae101c;
        font-size: 13px;
    }
}
.fileSuccess {
    margin: 10px 20px 15px 0;
    padding: 10px 15px 10px 15px;
    background-color: #f2faeb;
    border: #c5d8b5 1px solid;
    p {
        margin: 0;
        color: #4e841d;
        font-size: 13px;
    }
}
#uploadBox {
    border: 2px dashed hsla(0,0%,71.8%,.35);
    padding: 5px;
    margin-right: 30px;
}
.progress {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: 1rem;
	overflow: hidden;
	font-size: .75rem;
	background-color: #fff;
	border-radius: .25rem;
    box-sizing: border-box;
    width: 80%;
    .progress-bar-animated {
        -webkit-animation: progress-bar-stripes 1s linear infinite;
        animation: progress-bar-stripes 1s linear infinite;
    }
    .progress-bar-striped {
        background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
        background-size: 1rem 1rem;
    }
    .progress-bar-striped {
        background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
        background-size: 1rem 1rem;
    }
    .progress-bar {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        color: #fff;
        text-align: center;
        background-color: #007bff;
        transition: width .6s ease;
    }

}
</style>
